import isEmpty from 'lodash/isEmpty';
import * as common from '../apiCommon';
import { CUSTOM_FORM } from '../../constants/constant_doc_types';

export const fetchCustomFormById = (app, params) => {
  const { id } = params;
  const docType = CUSTOM_FORM;

  return common.getDoc(app, { id, docType });
};

export const saveCustomForm = (app, dataToSave) => {
  const { user = {}, data } = dataToSave;

  data.tabs = (data.tabs || []).filter(
    tab => tab.assigned_doc_type && tab.custom_tab_id,
  );

  const customFormData = {
    active: data.active,
    description: data.description,
    doc_type: CUSTOM_FORM,
    doc_types_applied_to: data.doc_types_applied_to,
    markup: data.markup,
    name: data.name,
    tabs: isEmpty(data.tabs)
      ? undefined
      : data.tabs.map(({ assigned_doc_type, custom_tab_id }) => ({
          assigned_doc_type,
          custom_tab_id,
        })),
    validation_code: data.validation_code,
    after_checkout_code: data.after_checkout_code,
    after_pay_code: data.after_pay_code,
    before_checkout_code: data.before_checkout_code,
    before_pay_code: data.before_pay_code,
    custom_descriptor_code: data.custom_descriptor_code,
  };

  return common.saveDoc(app, {
    source: data,
    doc: customFormData,
    user,
  });
};

export const deleteCustomForm = (app, data) => {
  return common.deleteDoc(app, {
    id: data.id,
    docType: CUSTOM_FORM,
  });
};
